import { render, staticRenderFns } from "./LaboratorioFormulario.vue?vue&type=template&id=92b71056"
import script from "./LaboratorioFormulario.vue?vue&type=script&lang=js"
export * from "./LaboratorioFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports